var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAlien = function SvgIconAlien(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.162 12.463c.421.422.992.66 1.588.662v-.375A2.26 2.26 0 0 0 7.5 10.5v.375a2.26 2.26 0 0 0 .662 1.588M14.25 13.125v-.375a2.26 2.26 0 0 1 2.25-2.25v.375a2.26 2.26 0 0 1-2.25 2.25M10.875 16.25a1 1 0 1 0 0 2h2.25a1 1 0 1 0 0-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 1.25a9.25 9.25 0 0 0-9.25 9.25c0 2.593 1.458 5.618 3.2 7.935.886 1.176 1.886 2.226 2.888 2.992.97.742 2.08 1.323 3.162 1.323s2.191-.58 3.162-1.323c1.002-.766 2.002-1.816 2.887-2.992 1.743-2.317 3.201-5.342 3.201-7.935A9.25 9.25 0 0 0 12 1.25M6.873 5.373A7.25 7.25 0 0 1 19.25 10.5c0 1.963-1.167 4.563-2.8 6.732-.802 1.067-1.677 1.975-2.503 2.606-.857.656-1.53.912-1.947.912s-1.09-.256-1.947-.912c-.826-.63-1.701-1.539-2.504-2.606C5.917 15.063 4.75 12.463 4.75 10.5a7.25 7.25 0 0 1 2.123-5.127",
    clipRule: "evenodd"
  }))));
};
export default SvgIconAlien;